export default __webpack_public_path__ + "static/screentwo-0b49fbf5c90d8a082730de44653619e1.png";